import React, { useEffect, useState } from 'react'

// Deps
import omit from 'lodash/omit'

// Functions
import isExact from 'functions/is-exact'

// Partials
import Btn from 'views/shared/partials/btn'

// Constants
const omitList = ['children', 'className', 'big', 'emptyPlus']

const QuantityInput = ({value, onChange, children, ...props}) => {
	const [btnProps, setBtnProps] = useState(omit(props, omitList));

	useEffect(() => {
		let newProps = omit(props, omitList);

		if(!isExact(newProps, btnProps)){
			setBtnProps(newProps);
		}
	}, [props, btnProps])

	return (
		<div {...btnProps} className={'quantity-input ' + (props.big ? ' big ' : '') + ((props.emptyPlus && value > props.min) ? ' added ' : '') + (props.className ? props.className : '')}>
			{props.emptyPlus && value === 0 ?
				<Btn
					className="input-addbtn"
					icon="plus"
					onClick={() => { if (!(props.max && value < props.max)) { onChange(value + 1) } }}
					big={props.big ? true : undefined}>
					{children ? children : 'Sepete Ekle'}
				</Btn>
			:
				<>
					<Btn
						className="input-controlbtn minus"
						icon="minus"
						disabled={value === props.min}
						onClick={() => { if(value > props.min) { onChange(value - 1) }}}
						big={props.big ? true : undefined} />
					<div className="input-quantity">{value}</div>
					<Btn
						className="input-controlbtn plus"
						icon="plus"
						disabled={props.max !== false && value >= props.max}
						onClick={() => { if(!(props.max !== false && value >= props.max)) { onChange(value + 1) } }}
						big={props.big ? true : undefined} />
				</>
			}
		</div>
	)
}

QuantityInput.defaultProps = {
	emptyPlus: false,
	min: 0,
	value: 0,
	max: false,
}

export default QuantityInput;